import React, {useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import swal from 'sweetalert';
import useDealOfTheDay from "./useDealOfTheDay";

export default function () {
  const {handleSubmit, dealOfTheDayFields, setData, setErrors } = useDealOfTheDay();

  const navigate = useNavigate();

  useEffect(() => {
    axios.get('product-lists/create').then(res => {
      if(res.data.status === 'success'){
        setData(res.data)
      }
    });
  }, []);

  const create = data => {
    axios.post('product-lists', data)
      .then(function (res) {
        if (res.status == 200) {
          swal('List has been updated successfully!', {
            icon: "success",
          });
          navigate("/deal-of-the-day");
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.errors || {});
        }
      });
  }

  return (
    <Card title="Create deal of the day product">
      <form className="form w-100 row" onSubmit={handleSubmit(create)}>

        {dealOfTheDayFields}

        <SubmitButton
          title="Save"
          classes="w-auto d-inline-block mt-4"
        />
      </form>
    </Card>
  );
}